import Occasion from "@/models/api/occasion/Occasion";
import OccasionCreate from "@/models/api/occasion/OccasionCreate";
import axios, { AxiosResponse } from "axios";
import ParticipantGroupRegistrationRequest from '@/models/api/participant-group/ParticipantGroupRegisterRequest';

class Service {
    public async RemoveParticipant(data: any) {
        return axios.post("api/occasion/RemoveParticipant", data);
    }
    public async AddParticipant(participant: any): Promise<AxiosResponse<any>> {
        return axios.post("api/occasion/AddParticipant", participant);
    }

    public async SaveOccasion(occasion: Occasion): Promise<AxiosResponse<any>> {
        return axios.post("api/occasion/", occasion);
    }

    public async CreateOccasion(occasion: OccasionCreate): Promise<AxiosResponse<any>> {
        return axios.post("api/occasion/CreateOccasion", occasion);
    }
    
    public async SetParticipantsConfirmed(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/occasion/SetParticipantsConfirmed', data);
    }
    
    public async SetIsTemporaryLeader(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/occasion/SetIsTemporaryLeader', data);
    }

    public async SetIsPresent(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/occasion/SetIsPresent', data);
    }

    public async GetRecurringOccasions(occasionId: number) {
        return axios.get(`api/occasion/GetRecurringOccasions?occasionId=${occasionId}`);
    }

    public async GetParticipants(occasionId: number): Promise<AxiosResponse<any[]>> {
        return axios.get(`api/occasion/GetParticipants?occasionId=${occasionId}`);
    }

    public async GetLocations(searchText: string): Promise<AxiosResponse<string[]>> {
        return axios.get(`api/occasion/GetLocations?searchText=${searchText}`);
    }

    public async GetComing(groupId?: number): Promise<AxiosResponse<any>>  {
        return axios.get("api/occasion/GetComing" + (groupId ? `?groupId=${groupId}` : ""));
    }

    public async GetOccasionsPaged(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/occasion/GetOccasionsPaged', data);
    }

    public async GetUnconfirmedPaged(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/occasion/GetUnconfirmedPaged', data);
    }

    public async GetConfirmedPaged(data: any): Promise<AxiosResponse<any>> {
        return axios.post('api/occasion/GetConfirmedPaged', data);
    }

    public async GetOccasion(id: number): Promise<AxiosResponse<Occasion>> {
        return axios.get(`api/occasion/${id}`);
    }

    public async RemoveOccasion(id: number): Promise<AxiosResponse<any>> {
        return axios.delete(`api/occasion/${id}`);
    }

    public async RemoveOccasionAndFollowing(occasionId: number): Promise<AxiosResponse<any>> {
        const data = { occasionId: occasionId };
        return axios.post(`api/occasion/RemoveOccasionAndFollowing`, data);
    }
}

export const OccasionService: Service = new Service();
